namespace Portico.Tfs {
    angular.module('app').directive('tfsBuildView', [
        function() {
            class Controller {
                build: Build.Get.Response;
                name: string;
                panel: { [index: string]: boolean };

                constructor(
                    private $scope: ng.IScope,
                    private $attrs: ng.IAttributes,
                    private tfsService: TfsService
                ) {
                    this.name = $attrs['name'];
                    $scope.$on('tfs:update', () => this.update());
                }

                get isComplete() {
                    return this.build && this.build.status === 'completed';
                }
                get buildUrl() {
                    return this.build && this.build._links.web.href;
                }
                get commitUrl() {
                    return (
                        this.build &&
                        `https://tfs.trialcard.com/DevCollection/Portico/Team%20Portals%20to%20Go/_git/Portico/commit/${
                            this.build.sourceVersion
                        }`
                    );
                }
                get compareUrl() {
                    return (
                        this.build &&
                        `https://tfs.trialcard.com/DevCollection/_git/Portico/branches?baseVersion=GBmaster&targetVersion=GC${
                            this.build.sourceVersion
                        }&_a=commits`
                    );
                }

                release() {
                    (<any>this.$scope.$parent).tfs.onRelease();
                }

                sync() {
                    (<any>this.$scope.$parent).tfs.sync();
                }

                update() {
                    if (!this.build) {
                        this.panel = {
                            'panel-info': true,
                        };
                        return;
                    }

                    this.panel = {
                        'panel-success': this.build.result === 'succeeded',
                        'panel-info':
                            this.build.status === 'inProgress' ||
                            this.build.status === 'notStarted',
                        'panel-danger': this.build.result === 'failed',
                        'panel-warning': this.build.result === 'partiallySucceeded',
                    };
                }

                $onInit() {
                    this.$scope.$watch<Build.List.Value>('ctrl.build', build => {
                        this.update();
                    });
                }
            }
            return {
                scope: { build: '=' },
                bindToController: true,
                controllerAs: 'ctrl',
                template: `
<div class="panel" ng-class="ctrl.panel">
    <div class="panel-heading">
        {{ ctrl.name }}
        <div class="pull-right" style="margin-top: -4px;">
            <a class="btn btn-default btn-sm" href="" style="display: inline-block; margin-left: 4px;" alt="trigger build" title="trigger build" ng-click="ctrl.release()">
                <span class="glyphicon glyphicon-cloud-upload"></span>
            </a>
            <!--
            <a class="btn btn-default btn-sm" href="" style="padding: 4px;margin-left: 4px;" title="sync with tfs" target="_blank" ng-click="ctrl.sync()">
                <div style="background-image: url(https://cdn.vsassets.io/content/icons/favicon.ico);height: 20px;width: 20px;background-size: contain;"></div>
            </a>
            -->
            <a class="btn btn-default btn-sm" title="view build" ng-href="{{ ctrl.buildUrl }}" target="_blank">
                <i class="fas fa-terminal"></i>
            </a>
        </div>
    </div>
    <table class="table">
        <tr>
            <td>Build Number:</td>
            <td><a ng-href="{{ ctrl.buildUrl }}" target="_blank">{{ ctrl.build.buildNumber }}</a></td>
        </tr>
        <tr ng-if="ctrl.isComplete">
            <td>Finished:</td>
            <td>{{ ctrl.build.finishTime | date:'medium' }}</td>
        </tr>
        <tr ng-if="!ctrl.isComplete">
            <td>Started:</td>
            <td>{{ ctrl.build.startTime | date:'medium' }}</td>
        </tr>
        <tr ng-if="ctrl.isComplete">
            <td>Result:</td>
            <td>{{ ctrl.build.result }}</td>
        </tr>
        <tr ng-if="!ctrl.isComplete">
            <td>Status:</td>
            <td>{{ ctrl.build.status }}</td>
        </tr>
        <tr>
            <td>
                Commit:
                <a class="btn btn-default btn-sm pull-right" title="view commit" style="display: inline-block; margin-left: 4px;" ng-href="{{ctrl.commitUrl}}" target="_blank">
                    <i class="fab fa-git"></i>
                </a>
            </td>
            <td><a ng-href="{{ctrl.commitUrl}}" target="_blank">{{ ctrl.build.sourceVersion | limitTo:8 }}</a></td>
        </tr>
        <tr>
            <td>
                Compare:
                <a class="btn btn-default btn-sm pull-right" title="view compare" style="display: inline-block; margin-left: 4px;" ng-href="{{ctrl.compareUrl}}" target="_blank">
                    <i class="fas fa-code-branch"></i>
                </a>
            </td>
            <td><a ng-href="{{ctrl.compareUrl}}" target="_blank">master <=> {{ ctrl.build.sourceVersion | limitTo:8 }}</a></td>
        </tr>
    </table>
</div>`,
                controller: [
                    '$scope',
                    '$attrs',
                    'tfsService',
                    Controller as any],
            };
        },
    ]);
}
